import type { LoginType } from '../auth/models/auth.model';
import type { Video } from '../content/models/video.interface';
import type { ProductContent } from '../content/models/product.interface';
import type { Membership } from '../membership/models/membership.model';

export interface NeedAccessReq {
  contentId: string;
  contentType: NeedAccessContentType;
}

export interface NeedAccessResponse {
  content?: Video;
  accessResponse: AccessResponse;
  loginTypes: LoginType[];
  keyProducts: ProductContent[];
  keyListings: KeyListing[];
  keyMemberships: Membership[];
}

export interface KeyListing {
  title: string;
  url: string;
}

export enum NeedAccessContentType {
  PAGE = 'PAGE',
  VIDEO = 'VIDEO',
  ALBUM = 'ALBUM',
  TRACK = 'TRACK',
  PRODUCT = 'PRODUCT',
  POST = 'POST',
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
  PERKS = 'PERKS',
  MEMBERSHIPS = 'MEMBERSHIPS',
}

export enum AccessResponse {
  ACCESS_GRANTED = 'ACCESS_GRANTED',
  ACCESS_DENIED = 'ACCESS_DENIED',
  REQUEST_LOGIN = 'REQUEST_LOGIN',
}
